import { differenceInSeconds, format } from 'date-fns';

// get difference in seconds between today and now time
export function getTodayDifferenceInSeconds(): number {
  const dateNow = new Date();
  const startDateNow = new Date(format(dateNow, 'yyyy/MM/dd'));

  return differenceInSeconds(dateNow, startDateNow);
}
